export default {
  remain: {
    en: 'Add <b class="text-gold-50">{remain}</b> to your order for <b class="uppercase text-gold-50">Free shipping</b>',
  },
  qualify: {
    en: 'You now qualify for <b class="uppercase text-gold-50">Free shipping</b>',
  },
}
